import { queryOptions } from '@tanstack/vue-query'
import { type MaybeRefOrGetter, toValue } from 'vue'
import { fetchUploadedFile } from '@/shared/api/uploads/fetchUploadedFile'
import { fetchUser } from '@/shared/api/users/fetchUser'

export const UploadedFileQueries = {
  all: () => queryOptions({ queryKey: ['uploads'] }),

  fetch: (uploadId: MaybeRefOrGetter<string>) => queryOptions({
    queryKey: [...UploadedFileQueries.all().queryKey, uploadId],
    queryFn: () => fetchUploadedFile(toValue(uploadId)),
    meta: {
      logger: 'shared/uploadedFiles.fetch'
    }
  }),
} as const

export const UserQueries = {
  fetch: (userId: MaybeRefOrGetter<string>) => queryOptions({
    queryKey: ['users:details', userId],
    queryFn: () => fetchUser(toValue(userId))
  })
} as const
